document.querySelectorAll('input.mask').forEach((input: HTMLInputElement) => {
  console.log('input-mask');

  // Get the sibling hidden field that will hold the raw value
  const hiddenField = document.querySelector(`input[type="hidden"][name="${input.id.replace(/_/g, '.')}"]`) as HTMLInputElement;

  // Ensure the hidden field starts with the correct value
  if (!hiddenField.value && input.value) {
    hiddenField.value = input.value;
  }

  // On page load, if the hidden field has a value, mask the visible input
  if (hiddenField.value) {
    input.value = "*".repeat(hiddenField.value.length);
  }

  const handleBlur = () => {
    console.log('handle-blur');

    // Validate the raw input against the pattern
    if (!new RegExp(hiddenField.getAttribute('pattern') || '').test(input.value)) {
      input.value = ''; // Clear the input if invalid
      hiddenField.value = '';
      return;
    }

    // Store the raw value in the hidden field
    hiddenField.value = input.value;

    // Mask the input with asterisks
    input.value = "*".repeat(hiddenField.value.length);

    // Remove the pattern to allow for submission
    input.removeAttribute('pattern');
  };

  const handleFocus = () => {
    console.log('handle-focus');

    // Show the raw value in the input field
    input.value = hiddenField.value;

    // Restore the pattern
    const currentPattern = hiddenField.getAttribute('pattern');
    if (currentPattern) {
      input.setAttribute('pattern', currentPattern);
    }
  };

  input.addEventListener("blur", handleBlur);
  input.addEventListener("focus", handleFocus);
});
